import React from 'react';
import { getConsultants, getConsultantInfo } from 'actions/consultants';
import PersonPage from 'layouts/PersonPage';

const ConsultantPage = () => {
  return <PersonPage getInfo={getConsultantInfo} getList={getConsultants} endPoint="consultants" />;
};

export default ConsultantPage;
